import { render, staticRenderFns } from "./CategoryModalAdd.vue?vue&type=template&id=617580e6&scoped=true"
import script from "./CategoryModalAdd.vue?vue&type=script&lang=js"
export * from "./CategoryModalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617580e6",
  null
  
)

export default component.exports